import React from 'react';
import SparkleEffect from './SparkleEffect';
import BurningEffect from './BurningEffect';
import FrozenEffect from './FrozenEffect';
import ShadowEffect from './ShadowEffect';
import RainbowEffect from './RainbowEffect';
import ElectricEffect from './ElectricEffect';

interface ItemEffectsRendererProps {
  effects: string[]; // Array of effect IDs from item_effects table
  className?: string;
  size?: 'small' | 'medium' | 'large';
  intensity?: 'low' | 'medium' | 'high';
}

/**
 * Component that renders all visual effects for an item based on its applied_effects array
 * Maps effect IDs from the database to their corresponding visual components
 */
const ItemEffectsRenderer: React.FC<ItemEffectsRendererProps> = ({
  effects = [],
  className = '',
  size = 'medium',
  intensity = 'medium'
}) => {
  if (!effects || effects.length === 0) return null;

  // Check which effects are active
  const hasShiny = effects.includes('shiny');
  const hasBurning = effects.includes('burning');
  const hasFrozen = effects.includes('frozen');
  const hasShadow = effects.includes('shadow');
  const hasRainbow = effects.includes('rainbow');
  const hasElectric = effects.includes('electric');

  return (
    <>
      {/* Render all active effects as layers */}
      <SparkleEffect
        isShiny={hasShiny}
        className={className}
        size={size}
        intensity={intensity}
      />

      <BurningEffect
        isBurning={hasBurning}
        className={className}
        size={size}
        intensity={intensity}
      />

      <FrozenEffect
        isFrozen={hasFrozen}
        className={className}
        size={size}
        intensity={intensity}
      />

      <ShadowEffect
        isShadow={hasShadow}
        className={className}
        size={size}
        intensity={intensity}
      />

      <RainbowEffect
        isRainbow={hasRainbow}
        className={className}
        size={size}
        intensity={intensity}
      />

      <ElectricEffect
        isElectric={hasElectric}
        className={className}
        size={size}
        intensity={intensity}
      />
    </>
  );
};

export default ItemEffectsRenderer;
